import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faTimes, faPhone, faEnvelope, faLocationDot } from '@fortawesome/free-solid-svg-icons';

import './ModaleContact.scss';

// Repli affiché tant qu'aucune info personnalisée n'a été enregistrée via l'adminpanel.
export const DEFAULT_CONTACT = {
  telephone: '06 50 85 58 10',
  email: 'contact@epicerie-basique.fr',
  adresse: '17 rue Anatole France\n42300 Roanne',
};

function ModaleContact({ onClose }) {
  const [isOpen, setIsOpen] = useState(true);
  const [contact, setContact] = useState(DEFAULT_CONTACT);

  useEffect(() => {
    fetch('/api/contact')
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => { if (data && data.telephone) setContact(data); })
      .catch(() => {});
  }, []);

  const handleClose = () => {
    setIsOpen(false);
    setTimeout(() => onClose(), 300);
  };

  const adresseLines = contact.adresse.split('\n');

  return ReactDOM.createPortal(
    <div className="modal-backdrop">
      <div className={`overlay ${isOpen ? '' : 'closing'}`} onClick={handleClose}></div>
      <div className={`modal-content ${isOpen ? '' : 'closing'}`}>
        <button onClick={handleClose} className="close-button" aria-label="Fermer">
          <FontAwesomeIcon icon={faTimes} className='close-icon'/>
        </button>
        <h1 className='contact__h1'>Contact</h1>

        <div className='contact__list'>
          <a href={`tel:${contact.telephone.replace(/\D/g, '')}`} className='contact__row'>
            <span className='contact__icon'><FontAwesomeIcon icon={faPhone} /></span>
            <span className='contact__info'>
              <span className='contact__label'>Téléphone</span>
              <span className='contact__value'>{contact.telephone}</span>
            </span>
          </a>

          <a href={`mailto:${contact.email}`} className='contact__row'>
            <span className='contact__icon'><FontAwesomeIcon icon={faEnvelope} /></span>
            <span className='contact__info'>
              <span className='contact__label'>E-mail</span>
              <span className='contact__value'>{contact.email}</span>
            </span>
          </a>

          <a href="https://maps.app.goo.gl/1qD9hqRDZv3jgSMB9" target="_blank" rel="noopener noreferrer" className='contact__row'>
            <span className='contact__icon'><FontAwesomeIcon icon={faLocationDot} /></span>
            <span className='contact__info'>
              <span className='contact__label'>Adresse</span>
              <span className='contact__value'>
                {adresseLines.map((line, i) => (
                  <React.Fragment key={i}>
                    {line}
                    {i < adresseLines.length - 1 && <br />}
                  </React.Fragment>
                ))}
              </span>
            </span>
          </a>
        </div>

        <div className='contact-reseau__div'>
          <a href="https://www.facebook.com/epicerie.basique/" target="_blank" rel="noopener noreferrer" aria-label='lien vers Facebook'>
            <FontAwesomeIcon icon={faFacebook} size="2x" className='icon-modal' />
          </a>
          <a href="https://www.instagram.com/epiceriebasique/" target="_blank" rel="noopener noreferrer" aria-label='lien vers Instagram'>
            <FontAwesomeIcon icon={faInstagram} size="2x" className='icon-modal'/>
          </a>
        </div>
      </div>
    </div>,
    document.body
  );
}


export default ModaleContact;
